"use client";
import React from "react";
import Error500 from "../src/components/Error500/Error500";
import SingleColumnLayout from "@components/Layout/SingleColumnLayout";
import { useAppContext } from "@components/Provider";

//Component for handeling error on nested pages if error.js is not defined for those page(s)
const error = ({ error, reset }) => {
  // Log error details to the console
  // Explicitly log the error details
  console.error("Error caught in error.js:", {
    message: error.message,
    stack: error.stack,
    digest: error.digest, // Available in Next.js for app router errors
    url: window.location.href,
  });

  const {
    siteId,
  } = useAppContext();
  return (
    <SingleColumnLayout siteId={siteId}>
      <Error500 error={error} isNewAppRouter={true} />
    </SingleColumnLayout>
  );
};

export default error;
